// shared/SoyTiendaHeader.jsx

import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ShoppingBag } from "lucide-react";
import { brand } from "./brand";

const NAV_ITEMS = [
  { label: "Beneficios", id: "beneficios" },
  { label: "Proceso", id: "proceso" },
  { label: "Cobertura", id: "cobertura" },
  { label: "Precios", id: "precios" },
];

function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function SoyTiendaHeader() {
  return (
    <header className="sticky top-0 z-50 border-b bg-white/85 shadow-sm backdrop-blur-xl" style={{ borderColor: brand.line }}>
      <nav className="mx-auto flex h-14 max-w-7xl items-center justify-between gap-3 px-4">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="FAST MAX" className="h-7 w-auto" />
          <span className="hidden text-base font-black italic tracking-wide sm:inline" style={{ color: brand.primary }}>
            FAST MAX
          </span>
        </Link>

        <div className="hidden items-center gap-5 text-xs font-bold md:flex" style={{ color: brand.muted }}>
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              type="button"
              onClick={() => scrollToSection(item.id)}
              className="bg-transparent p-0 font-bold hover:opacity-70"
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <Link
            to="/tienda"
            className="hidden items-center gap-1.5 rounded-xl border px-3 py-1.5 text-xs font-bold text-white transition-all duration-200 sm:flex"
            style={{ background: brand.primary, borderColor: brand.primary }}
          >
            <ShoppingBag className="size-3.5" />
            Comprar
          </Link>

          <Link
            to="/login"
            className="hidden items-center rounded-xl border bg-white px-3 py-1.5 text-xs font-bold whitespace-nowrap transition-colors hover:bg-slate-50 sm:inline-flex"
            style={{ borderColor: brand.line, color: brand.ink }}
          >
            Iniciar sesión
          </Link>

          <Link
            to="/register"
            className="inline-flex items-center gap-1 rounded-xl px-3 py-1.5 text-xs font-bold text-white whitespace-nowrap"
            style={{ background: brand.primary }}
          >
            Crear cuenta
            <ChevronRight className="size-3.5" />
          </Link>
        </div>
      </nav>
    </header>
  );
}
